export { default as Img200 } from './processed/200/jerrod-carmichael-8.jpg';
export { default as Img400 } from './processed/400/jerrod-carmichael-8.jpg';
export { default as Imgthumb } from './processed/thumb/jerrod-carmichael-8.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/jerrod-carmichael-8.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/jerrod-carmichael-8.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      48,
      176,
      204
    ],
    "_population": 2,
    "_hsl": [
      0.5299145299145299,
      0.6190476190476191,
      0.49411764705882355
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      27,
      88,
      106
    ],
    "_population": 1926,
    "_hsl": [
      0.5379746835443039,
      0.5939849624060151,
      0.2607843137254902
    ]
  },
  "Muted": {
    "_rgb": [
      91,
      156,
      158
    ],
    "_population": 266,
    "_hsl": [
      0.5049751243781094,
      0.26907630522088355,
      0.4882352941176471
    ]
  },
  "LightMuted": {
    "_rgb": [
      180,
      156,
      132
    ],
    "_population": 2,
    "_hsl": [
      0.08333333333333333,
      0.2424242424242425,
      0.611764705882353
    ]
  },
  "DarkMuted": {
    "_rgb": [
      78,
      51,
      41
    ],
    "_population": 1094,
    "_hsl": [
      0.045045045045045036,
      0.31092436974789917,
      0.23333333333333334
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/jerrod-carmichael-8.js